import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminStoresTableView from './AdminStoresTableView';
import AdminStoreEscrowBalanceView from './AdminStoreEscrowBalanceView';
import AdminStoreViews from './AdminStoreViews';

const AdminStoresView = () => (
  <Routes>
    <Route element={<AdminStoreEscrowBalanceView />} path="/escrow-balance" />
    <Route element={<AdminStoreViews />} path="/:pkEcomStore/*" />
    <Route element={<AdminStoresTableView />} path="/" />
    <Route element={<Navigate replace to="/merchant/orders" />} path="*" />
  </Routes>
);

export default AdminStoresView;
